import React from "react";
import masVentas from "../../../src/assets/images/icon/masVentas.svg"
import multidispositivo from "../../../src/assets/images/icon/multidispositivo.svg"
import whatsApp from "../../../src/assets/images/icon/whatsApp.svg"
import soportePersonalizado from "../../../src/assets/images/icon/soportePersonalizado.svg"
import pasarela from "../../../src/assets/images/icon/pasarela.svg"
import dominio from "../../../src/assets/images/icon/dominio.svg"
import reportes from "../../../src/assets/images/icon/reportes.svg"
import { LazyLoadImage } from "react-lazy-load-image-component";
import PromoBanner from "./banners/PromoBanner";

const Benefits = () => {
    const featureContent = [
        {
            id: 1,
            icon: masVentas,
            title: "Más ventas",
            descriptions: `Tu tienda abierta todo el tiempo`,
            delayAnimationTime: 0,
        },
        {
            id: 2,
            icon: pasarela,
            title: "Pasarela",
            descriptions: `Pasarela de pago integrada`,
            delayAnimationTime: 100,
        },
        {
            id: 3,
            icon: multidispositivo,
            title: "Multidispositivo",
            descriptions: `Maneja tu negocio en cualquier dispositivo`,
            delayAnimationTime: 150,
        },
        {
            id: 4,
            icon: whatsApp,
            title: "WhatsApp",
            descriptions: `Habla ágilmente con tus clientes por WhatsApp`,
            delayAnimationTime: 200,
        },
        {
            id: 5,
            icon: reportes,
            title: "Reportes y análisis",
            descriptions: `Genera reportes y análisis de ventas personalizadas`,
            delayAnimationTime: 200,
        },
        // {
        //     id: 6,
        //     icon: whatsApp,
        //     title: "Plantillas",
        //     descriptions: `Personaliza tu tienda online con nuestras más de 100 plantillas`,
        //     delayAnimationTime: 150,
        // },
        {
            id: 7,
            icon: dominio,
            title: "Almacenamiento y dominio",
            descriptions: `Almacenamiento y dominio PowerBizz Gratis`,
            delayAnimationTime: 100,
        },
        {
            id: 8,
            icon: soportePersonalizado,
            title: "Soporte Personalizado",
            descriptions: `Agentes especializados y listos para ayudarte`,
            delayAnimationTime: 0,
        },
    ];
    return (
        <div className="flex flex-col lg:flex-row py-10 px-0 md:px-5" style={{ background: '#F5F5F5', borderRadius: '70px' }}>
            <div className="w-full lg:w-1/2">
                <PromoBanner />
            </div>
            <div className="Zcontainer w-full lg:w-1/2 flex items-end md:mr-4">
                {/* <h2 className="text-center text-[36px] md:text-[46px] font-[avenirblack]" style={{ color: '#8163FF' }}>
                    ¡E-commerce en simples pasos!
                </h2>
                <h3 className="text-center md:text-left text-[22px] md:text-[30px] font-[avenirblack] py-2">
                    Haz crecer tu negocio con una plataforma con los mejores cuadros de análisis, pasarela de pago integrado y soporte técnico especializado.
                </h3> */}
                <div className="row gx-xl-4 justify-content-center gap-4 gap-md-0">
                    {featureContent.map((item) => (
                        <div
                            className="col-sm-5 col-md-4 col-xl-4"
                            // data-aos="fade-up"
                            // data-aos-delay={item.delayAnimationTime}
                            key={item.id}
                        >
                            <div className="card-style-three flex flex-col items-center">
                                <div className="icon d-flex align-items-center justify-content-center bg-transparent">
                                    <LazyLoadImage src={item.icon} alt="icon" className="tran3s" />
                                </div>
                                <h4 className="title text-center">{item.title}.</h4>
                                <p>{item.descriptions}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Benefits;